import { AssistantPanelConversationEntryPoint } from "components/AssistantPanel/analytics/types";
import useAssistantPanelAnalytics from "components/AssistantPanel/analytics/useAnalytics";
import { ChatMode } from "components/AssistantPanel/Chat/types";
import useAssistantPanelSendPrompt from "components/AssistantPanel/hooks/useSendPrompt";
import { ChevronDown, Edit, LogoInfraAssistantColored } from "components/icons/generated";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import DropdownMenu from "ds/components/DropdownMenu";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import Icon from "ds/components/Icon";
import { AnalyticsPage } from "hooks/useAnalytics";
import useIntelligenceSettings from "shared/Intelligence/useIntelligenceSettings";

type PoliciesListCreatePolicyButtonProps = {
  onCreateManually: () => void;
  prompt: string;
  entryPoint: AssistantPanelConversationEntryPoint;
  analyticsPage: AnalyticsPage;
};

const PoliciesListCreatePolicyButton = ({
  onCreateManually,
  prompt,
  entryPoint,
  analyticsPage,
}: PoliciesListCreatePolicyButtonProps) => {
  const { canUseInfraAssistant } = useIntelligenceSettings();
  const { openPrompt, isChatOpen } = useAssistantPanelSendPrompt();
  const { trackConversationOpened } = useAssistantPanelAnalytics();

  const handleCreateWithAssistant = () => {
    trackConversationOpened(entryPoint);

    openPrompt(prompt, { newChat: !isChatOpen, mode: ChatMode.BUILD });
  };

  if (!canUseInfraAssistant) {
    return (
      <Button onPress={onCreateManually} variant="primary">
        Create policy
      </Button>
    );
  }

  return (
    <DropdownMenu
      placement="bottom right"
      triggerComponent={
        <Button variant="primary" endIcon={ChevronDown}>
          Create policy
        </Button>
      }
    >
      <DropdownMenuItem
        onAction={onCreateManually}
        analyticsPage={analyticsPage}
        analyticsTitle="Create Policy"
      >
        <Box gap="medium" align="center">
          <Icon src={Edit} />
          Create manually
        </Box>
      </DropdownMenuItem>

      <DropdownMenuItem
        onAction={handleCreateWithAssistant}
        analyticsPage={analyticsPage}
        analyticsTitle="Create Policy With Infra Assistant"
      >
        <Box gap="medium" align="center">
          <Icon src={LogoInfraAssistantColored} />
          Create with Infra Assistant
        </Box>
      </DropdownMenuItem>
    </DropdownMenu>
  );
};

export default PoliciesListCreatePolicyButton;
